<template>
    <div class="vue-active-marker" aria-live="polite">
        <div class="inner">
            <perfect-scrollbar>
                <button @click="handleClose" ref="backButton" class="close-toggle mb-4">{{ backText }}</button>

                <img v-if="hasImage" :src="marker.image" :alt="marker.title" class="mb-3 marker-image">

                <h3 class="virtual-h2">{{ marker.title }}</h3>

                <ul class="details">
                    <li>{{ marker.streetNumber }}</li>
                    <li>{{ marker.postalCodePlace }} </li>
                    <li class="divider"></li>
                    <li v-if="hasChargingStations" class="activemarker-charging-station">{{ `${chargingStationText}: ${marker.charging_stations}` }}</li>
                    <li v-if="parsedPhoneNumber"><a :href="`tel:${parsedPhoneNumber}`">{{ marker.tel }}</a></li>
                    <li v-if="hasEmail"><a :href="`mailto:${secureEmail}`" target="_blank">{{ emailText }} {{ marker.title }}</a></li>
                </ul>

                <a v-if="!isNexDriveUK" :href="`https://www.google.com/maps/dir//${ marker.geolocation.lat },${ marker.geolocation.lng }`" target="_blank" class="btn-secondary mt-4">{{ planRouteText }}</a>
                <a v-if="isNexDriveUK" :href="buttonWebsiteUrl" target="_blank" class="btn-secondary mt-4">{{ websiteButtonText }}</a>

                <div class="office-hours" v-if="marker.opening_hours">
                    <h4>{{ openingHoursTitle }}</h4>

                    <table class="w-100">
                        <thead class="visually-hidden">
                        <tr>
                            <th>{{ dayText }}</th>
                            <th>{{ hourText }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="day in marker.opening_hours.days" class="align-top" :class="{'current': day.active}">
                            <td>{{ day.name }}</td>

                            <td v-if="hasSlots(day.slots)">
                                <span class="d-block" v-for="slot in day.slots">
                                    {{ slot.open }} - {{ slot.closed }}
                                </span>
                            </td>

                            <td v-else>{{ closedText }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <a v-if="!isNexDriveUK" :href="buttonWebsiteUrl" class="simple-link mt-2">{{ websiteButtonText }} <span class="visually-hidden">{{ marker.title }}</span></a>
                <a v-if="isNexDriveUK" :href="`https://www.google.com/maps/dir//${ marker.geolocation.lat },${ marker.geolocation.lng }`" class="simple-link mt-2">{{ planRouteText }} <span class="visually-hidden">{{ marker.title }}</span></a>
            </perfect-scrollbar>
        </div>
    </div>
</template>

<script>
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';

export default {
    name: "ActiveMarker",

    props: ['marker', 'eventBus', 'domainId', 'countryCode'],

    data() {
        return {
            closedText: window.Drupal.t('Closed'),
            openingHoursTitle: window.Drupal.t('Opening hours'),
            planRouteText: window.Drupal.t('Plan route'),
            emailText: window.Drupal.t('E-mail'),
            backText: window.Drupal.t('Back'),
            dayText: window.Drupal.t('Days'),
            hourText: window.Drupal.t('Hours'),
            chargingStationText: window.Drupal.t('Charging stations'),
            websiteButtonText: window.Drupal.t('More information'),
        }
    },

    computed: {
        parsedPhoneNumber() {
            if (_.isEmpty(this.marker.tel)) {
                return;
            }

            return parsePhoneNumber(this.marker.tel, this.countryCode).number;
        },

        buttonWebsiteUrl() {
            return this.marker.garage_website ?? this.marker.url
        },

        secureEmail() {
            return this.marker.email.replaceAll('@','%40');
        },

        hasImage() {
            return ! _.isEmpty(this.marker.image);
        },

        hasChargingStations() {
            return !_.isEmpty(this.marker.charging_stations)
        },

        hasEmail() {
            return !_.isNil(this.marker.email);
        }
    },

    created() {
        this.$nextTick(() => {
            this.$refs.backButton.focus();
        });
    },

    methods: {
        handleClose() {
            this.eventBus.$emit('remove-active-marker');
        },

        hasSlots(slots) {
            return !_.isEmpty(slots);
        },

        isNexDriveUK() {
            return this.domainId === 'nexdrive_co_uk';
        }
    }
}
</script>